import { routes } from '@/app/routing/router'
import { TestPageView } from './view'

const currentRoute = routes.test

const TestPageRoute = {
  route: currentRoute,
  view: TestPageView,
}

export { currentRoute, TestPageRoute }
